'use strict';
import '../../sass/sidebar.scss';

export function Sidebar(id, model) {
  Object.defineProperties(this, {
    "id": {
      get: function() {return this._id;},
      set: function(value) {
        this._id = value || null;
      },
      enumerable: true
    },
    "model": {
      get: function() {return this._model;},
      set: function(values) {
        if(!values) {
          throw new TypeError('modelプロパティ値が指定されていません。');
        }
        if('id' in values) {
          throw new ReferenceError('渡された引数にidプロパティが含まれていません。');
        } else if('name' in values) {
          throw new ReferenceError('渡された引数にnameプロパティが含まれていません。');
        }
        this._model = values;
      },
      enumerable: true
    }
  });
  this.id = id;
  this.model = model;
};
Sidebar.prototype.create = function() {
  var df = document.createDocumentFragment();
  var container = document.createElement('div');
  container.id = 'sidebar';
  container.className = 'sidebar__container';
  df.appendChild(container);

  var list = document.createElement('ul');
  list.className = 'sidebar__list';
  df.firstChild.appendChild(list);

  this.model.forEach(function(item) {
    var menuItem = document.createElement('li');
    menuItem.className = 'sidebar__listitem';
    if(this.id === item.id) {
      menuItem.className += ' sidebar__listitem--active';
    }
    var menuAnchor = document.createElement('a');
    menuAnchor.href = '?type=category&id=' + item.id;
    menuAnchor.textContent = item.name;
    menuItem.appendChild(menuAnchor);
    df.querySelector('.sidebar__list').appendChild(menuItem);
  }.bind(this));
  return df;
};